module.exports = __webpack_public_path__ + "static/media/spinner.9e0fa8c9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinner.gif
// module id = 463
// module chunks = 0